export default __webpack_public_path__ + "pi1-1QAAT/components/SocialProof/images/name-ease-372579f710dd13391e4dfe605396c38a.svg";